import React from "react";
import { MdRefresh } from "react-icons/md";

export default function ReRequest({ reRequestAction }) {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-y-[3vw]">
      <span className="w-full text-center text-[3.5vw] font-font_primary_A text-color-primary-C">
        خطایی به وجود آمده است مجد تلاش نمایید
      </span>
      <button
        className="w-[60vw] h-[9vw] flex items-center justify-center gap-x-[2vw] bg-color-primary-B rounded-[0.9vw] font-font_primary_A text-[3.5vw] text-color-primary-A"
        onClick={reRequestAction}
      >
        <span>استعلام مجدد</span>
        <span>
          <MdRefresh size={20} />
        </span>
      </button>
    </div>
  );
}
